import { render, staticRenderFns } from "./LocationBody.vue?vue&type=template&id=0e0270f0"
import script from "./LocationBody.vue?vue&type=script&lang=js"
export * from "./LocationBody.vue?vue&type=script&lang=js"
import style0 from "./LocationBody.vue?vue&type=style&index=0&id=0e0270f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports